
























import { Component, Vue, Watch } from 'vue-property-decorator';
import PageHeader from '@/components/PageHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
import LoginPopup from '@/components/auth/LoginPopup.vue';
import AccountNoticesAlert from '@/components/auth/AccountNoticesAlert.vue';
import { authModule, snackModule } from '@/store';
import { Snack } from '@/store/Snack';
import { ApiError } from '@/api';
import { consumeLoginRedirect } from '@/accountNotices';
import { Route } from 'vue-router';

@Component({
  components: {
    PageHeader,
    PageFooter,
    LoginPopup,
    AccountNoticesAlert,
  },
})
export default class extends Vue {
  menuOpen: boolean = false;

  get ready(): boolean {
    return authModule.ready;
  }

  get isLoggedIn(): boolean {
    return authModule.isLoggedIn;
  }

  get nextQuery(): string {
    return typeof this.$route.query.next === 'string'
      ? this.$route.query.next
      : '';
  }

  get snacks(): Snack[] {
    return snackModule.snacks;
  }

  get showSnackbar(): boolean {
    return snackModule.snacksVisible;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  @Watch('$route', { immediate: true })
  titleChange(to: Route, from: Route) {
    if (
      (!from || from.name !== to.name) &&
      to.name !== 'auction' &&
      to.name !== 'dynamic-component'
    ) {
      if (to.meta.title) {
        document.title = to.meta.title + ' - Gowans Auctions';

        authModule.trackPageview({
          gtag: this.$gtag,
          route: to,
          pageTitle: to.meta.title,
        });
      } else {
        document.title = 'Gowans Auctions';
      }
    }
  }

  @Watch('$route.path')
  routeChanged() {
    this.menuOpen = false;
  }
  @Watch('isLoggedIn')
  @Watch('nextQuery')
  isLoggedInChange() {
    // redirect once logged in if next query param is set
    if (!this.isLoggedIn || !this.nextQuery) {
      return;
    }
    // Unless the login page has already claimed this login and is sending the
    // user to their outstanding notices. It carries the deep link along as
    // `?continue=` and offers it as a button, so nothing is lost - but both of
    // us navigating would be a race, and Vue's watcher queue and the router's
    // navigation settle independently.
    if (consumeLoginRedirect()) {
      return;
    }
    this.$router.replace(this.nextQuery);
  }
}
